import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, FormControl, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { format } from 'date-fns';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
});
class FormDialogHistoricoReembolso extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.historico,
    };
  }
  render () {
    const { classes, open, handleClose, titulo, acerto } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='sm'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <FormControl>
                <Table padding={'dense'}>
                  <TableHead>
                    <TableRow>
                      <TableCell title='Situação do Acerto'>Status</TableCell>
                      <TableCell title='Nome do Usuário'>Usuário Cadastro</TableCell>
                      <TableCell title='Data do Cadastro'>Data Cadastro</TableCell>
                      <TableCell title='Motivo do Cancelamento'>Observação</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {acerto.historicos.slice(0).map((historico, idx) => {
                      return (
                        <TableRow
                          key={idx}>
                          <TableCell>{historico.desEstadoAcerto}</TableCell>
                          <TableCell>{historico.nomUsuario}</TableCell>
                          <TableCell>{format(new Date(historico.dtaCadastro), 'DD/MM/YYYY HH:mm:ss')}</TableCell>
                          <TableCell style={{width: 'auto'}}>{historico.txtObservacao === null || historico.txtObservacao === '' ? '-' : historico.txtObservacao}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </FormControl>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogHistoricoReembolso);
